import React, { Component } from 'react';

class Header extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var occupation= this.props.data.occupation;
      var description1= this.props.data.description1;
      var description2= this.props.data.description2;
      var skill= this.props.data.skill;
      var location= this.props.data.address.location;
      var networks= this.props.data.social.map(function(network){
        return <li key={network.name}><a href={network.url}><i className={network.className}></i></a></li>
      })
      var programming= this.props.data.languages.map(function(programming){
        return <li key={programming.name}><a href={programming.url}><i className={programming.className}></i></a></li>
      })
    }

    return (
      <header id="home">

      <nav id="nav-wrap">

         <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
	      <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

         <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            <li><a className="smoothscroll" href="#about">About</a></li>
	          <li><a className="smoothscroll" href="#resume">Resume</a></li>
            <li><a className="smoothscroll" href="#publication">Publications</a></li>
            <li><a className="smoothscroll" href="#demo">Demos</a></li>
         </ul>

      </nav>

      <div className="row banner">
         <div className="banner-text">
            <h1 className="responsive-headline">I'm {name}.</h1>
            <h3>I'm a {location} based</h3>
            <h3><span>{occupation}</span>.</h3>
            <h3>{description1}</h3>
            <h3>{description2}</h3>
            <hr />
            <ul className="social">
               {networks}
            </ul>
            <h3>{skill}</h3>
            <ul className="skillicon">
               {programming}
            </ul>
         </div>
      </div>

      <p className="scrolldown">
         <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
      </p>

   </header>
    );
  }
}

export default Header;
